export default "__VITE_ASSET__CJY_3PKr__"